import { Component, Input } from '@angular/core';
import { TagForm } from '../../forms/tag.form';
import { TagListDialogCloseAction } from '../../models/tag-list-dialog-close-action.enum';
import { Tag } from '../../models/tag.model';

@Component({
standalone: false,
  selector: 'app-tag-list-add',
  styleUrls: ['./tag-list-add.component.scss'],
  templateUrl: './tag-list-add.component.html',
})
export class TagListAddComponent {
  @Input() public tags: Tag[];
  @Input() public filteredTags: Tag[];
  @Input() public parentName: string;
  @Input() public customerBillerId: string;
  @Input() public subAccountId: string;
  @Input() public closeAction: string;
  @Input() public form: TagForm;
  @Input() public edit: (tag: Tag) => void;
  @Input() public addCustomTag: (name: string) => void;
  @Input() public cancel: () => void;
  @Input() public checkChange: (tag: Tag) => void;

  public closeActionEnum = TagListDialogCloseAction;

  constructor() {}
}
